import { render } from "./Print3DCategoriasPage.vue?vue&type=template&id=b2d8fc12&scoped=true"
import script from "./Print3DCategoriasPage.vue?vue&type=script&lang=js"
export * from "./Print3DCategoriasPage.vue?vue&type=script&lang=js"

import "./Print3DCategoriasPage.vue?vue&type=style&index=0&id=b2d8fc12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d8fc12"]])

export default __exports__